import styled, { css } from "styled-components";

export const Container = styled.div(
    ({ theme }) => css`
        background: #fff;
        border-radius: 4px;
        padding: 8px;
        min-height: calc(100vh - 130px);
    `
);

export const StyledHeader = styled.h1(
    ({ theme }) => css`
        color: ${theme.palette.common.blue};
        margin: 0;
        font-size: 26px;
        line-height: 1.5;
        font-weight: 600;
        text-transform: capitalize;
        margin-bottom: 60px;
        @media (max-width: 500px) {
            font-size: 4.2vw;
        }
    `
);
